/** Cliente HTTP das Missões (lado do jogador). Ver backend MissionController. */

export interface MissionSummary {
  id: string;
  name: string;
  levels_count: number;
  energy_cost: number;
  coin_cost: number;
  /** Tentativa em andamento (active / awaiting_portal), ou null. `level` é 0-based. */
  current_run: { id: string; status: string; level: number } | null;
  /** Nível 0-based em que o jogador entra agora (checkpoint ou tentativa em andamento). */
  start_level: number;
}

/** Grupo do jogador (2+). Só o líder inicia; os outros entram junto. */
export interface MissionPartyInfo {
  size: number;
  is_leader: boolean;
}

export interface MissionEnterResult {
  success: boolean;
  combat_id: string;
  player_entity_id: string;
  run_id: string;
  level: number;
}

export interface MissionRunInfo {
  success: boolean;
  run: {
    id: string; mission_id: string; status: string; level: number; checkpoint_level: number | null; combat_id: string | null;
    /** Quantos jogadores na tentativa (1 = solo). */
    players: number;
    /** Entidade de quem perguntou no combate atual ('player_N'). */
    my_entity_id: string;
  };
  mission: { name: string; levels_count: number; defeat_destination: 'hub' | 'dashboard' } | null;
}

async function call<T>(url: string, token: string, method: 'GET' | 'POST' = 'GET'): Promise<T> {
  const res = await fetch(url, {
    method,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  });
  const data = (await res.json().catch(() => ({}))) as T & { success?: boolean; error?: string };
  if (!res.ok || data.success === false) {
    const err = new Error(data.error ?? `HTTP ${res.status}`);
    console.error(`[API] ${method} ${url} failed:`, err);
    throw err;
  }
  return data;
}

export const missionApi = {
  /** Missões de um portal do Hub (`portalKey` = "X_Y"); fixa → só ela. */
  list: (token: string, portalKey: string) =>
    call<{ success: boolean; missions: MissionSummary[]; party: MissionPartyInfo | null }>(`/api/missions?portal=${encodeURIComponent(portalKey)}`, token),
  enter: (token: string, missionId: string) =>
    call<MissionEnterResult>(`/api/missions/${missionId}/enter`, token, 'POST'),
  advance: (token: string, runId: string) =>
    call<MissionEnterResult>(`/api/missions/runs/${runId}/advance`, token, 'POST'),
  getRun: (token: string, runId: string) =>
    call<MissionRunInfo>(`/api/missions/runs/${runId}`, token),
};
